import React from 'react';

interface ImageCarouselProps {
  images: string[];
  variant: 'vertical' | 'horizontal';
  speed?: 'slow' | 'medium' | 'fast';
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  variant,
  speed = 'medium'
}) => {
  const speedClass = {
    slow: variant === 'vertical' ? 'animate-marquee-vertical-slow' : 'animate-marquee-horizontal-slow',
    medium: variant === 'vertical' ? 'animate-marquee-vertical' : 'animate-marquee-horizontal',
    fast: variant === 'vertical' ? 'animate-marquee-vertical-fast' : 'animate-marquee-horizontal-fast'
  }[speed];

  if (variant === 'vertical') {
    const column1 = images.filter((_, i) => i % 2 === 0);
    const column2 = images.filter((_, i) => i % 2 === 1);

    return (
      <div className="hidden lg:flex relative h-[600px] gap-4 overflow-hidden">
        {/* Gradient overlays for smooth fade */}
        <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-[#FAF9F6] to-transparent z-10 pointer-events-none" />
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#FAF9F6] to-transparent z-10 pointer-events-none" />
        {/* Columna 1 */}
        <div className="flex-1 flex flex-col gap-4 overflow-hidden">
          <div className={`flex flex-col gap-4 ${speedClass}`}>
            {[...column1, ...column1].map((img, idx) => (
              <div
                key={idx}
                className="relative w-full h-64 rounded-2xl overflow-hidden shadow-xl border-4 border-white flex-shrink-0"
              >
                <img
                  src={img}
                  alt={`Familia ${idx + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Columna 2 - Desplazamiento inverso */}
        <div className="flex-1 flex flex-col gap-4 overflow-hidden">
          <div className={`flex flex-col gap-4 ${speedClass} animation-reverse`}>
            {[...column2, ...column2].map((img, idx) => (
              <div
                key={idx}
                className="relative w-full h-64 rounded-2xl overflow-hidden shadow-xl border-4 border-white flex-shrink-0"
              >
                <img
                  src={img}
                  alt={`Familia ${idx + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Horizontal variant
  return (
    <div className="lg:hidden relative w-full h-48 overflow-hidden mt-8">
      {/* Gradientes de fusión laterales */}
      <div className="absolute top-0 left-0 w-16 h-full bg-gradient-to-r from-[#FAF9F6] to-transparent z-10 pointer-events-none" />
      <div className="absolute top-0 right-0 w-16 h-full bg-gradient-to-l from-[#FAF9F6] to-transparent z-10 pointer-events-none" />

      <div className={`flex gap-4 ${speedClass}`}>
        {[...images, ...images].map((img, idx) => (
          <div
            key={idx}
            className="relative w-72 h-48 rounded-2xl overflow-hidden shadow-xl border-4 border-white flex-shrink-0"
          >
            <img
              src={img}
              alt={`Familia ${idx + 1}`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
